import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { AuthService } from './services/auth.service';
import * as data from 'assets/data/permissions.json';

@Injectable()
export class CanActivateAuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot) {
    // If the user is not logged in we'll send them back to the home page
    if (!this.authService.isAuthenticated()) {
      if (route.params.client)
        this.router.navigate(['/auth/login', route.params.client]);
      else
        this.router.navigate(['/auth/login', ""]);

      return false;
    }

    return true;
  }
}
